const delay = () => new Promise((res) => setTimeout(res, 0));

export default delay;